import {animateByClass} from '../Library/Animation';

export const toggleRows = (handle) => {
    const targetId   = handle.dataset.expandableRows;
    const rows       = document.querySelectorAll(`[data-expandable-row="${targetId}"]`);
    const isExpanded = handle.hasAttribute('data-expanded');

    if (isExpanded) {
        handle.removeAttribute('data-expanded');

        rows.forEach(row => {
            animateByClass(row, 'hiding').then(() => row.classList.add('hidden-row'));
        });
    } else {
        handle.setAttribute('data-expanded', '');

        rows.forEach(row => {
            row.classList.remove('hidden-row');
            animateByClass(row, 'revealing');
        });
    }
};
